import PdfLineItem from "./PdfLineItem";

export default class PdfProcessedPage {
    page_number: number;
    vendor: string;
    project_NaN: string;
    invoice_NaN: string;
    line_items: PdfLineItem[] | null;
    total: number | null;

    constructor(partial: Partial<PdfProcessedPage>) {
        this.page_number = partial.page_number ?? 0
        this.vendor = partial.vendor ?? ""
        this.project_NaN = partial.project_NaN ?? ""
        this.invoice_NaN = partial.invoice_NaN ?? ""
        this.line_items = partial.line_items ?? null
        this.total = partial.total ?? null
    }
}